import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Reveal } from "@/components/Reveal";
import { EstimateCTASection } from "@/components/Sections";
import { EstimateButton, CallButton, TextButton } from "@/components/CTAButtons";
import { faqs } from "@/data/site";

export default function FAQ() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <Seo
        title="Junk Removal FAQ | Benji's Hauling & Junk Removal"
        description="Answers to common junk removal questions: pricing (starting at $99), free estimates, what we take, recycling & donation, heavy materials, and the story behind Benji's dog treats."
        path="/faq"
        jsonLd={jsonLd}
      />
      <Breadcrumbs items={[{ label: "FAQ" }]} />
      <PageHero
        eyebrow="FAQ"
        title="Frequently Asked Questions"
        sub="Everything you need to know before you book, from pricing and free estimates to what we can take away. Still curious? Just call or text."
      >
        <div className="flex flex-wrap gap-3">
          <CallButton variant="primary" />
          <TextButton variant="ghostLight" />
        </div>
      </PageHero>

      <section className="bg-cream py-20">
        <div className="container-x">
          <Reveal className="mx-auto max-w-3xl">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem key={i} value={`item-${i}`} className="border-b border-border">
                  <AccordionTrigger data-testid={`faq-q-${i}`} className="py-5 text-left font-heading text-base font-bold text-forest hover:text-gold-dark hover:no-underline sm:text-lg">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-sm leading-relaxed text-charcoal/75 sm:text-base">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>

          <Reveal className="mx-auto mt-10 max-w-3xl rounded-lg border border-border bg-accent/40 p-8 text-center">
            <h2 className="font-heading text-xl font-bold text-forest">Still have questions?</h2>
            <p className="mt-2 text-sm text-charcoal/70">We're happy to help. Reach out and we'll get you a free estimate.</p>
            <div className="mt-5 flex flex-wrap justify-center gap-3">
              <EstimateButton label="Get a Free Estimate" />
              <CallButton variant="forest" />
            </div>
          </Reveal>
        </div>
      </section>

      <EstimateCTASection />
    </>
  );
}
